/* eslint-disable camelcase */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Consent from '../../common/Consent';

const FormInputs = ({
    t, handleChange, name, email, phone, message, agreement_data, agreement_marketing, agreement_rodo, error, responseType, errorType, consents, sending
}) => (
    <div className="estimation-form-inputs">
        <div className="estimation-form-inputs-bg" id="estimation-form-inputs-bg">
            <img src={ require('../../../../assets/images/security/3/bg.svg') } alt="Lemlock threats"/>
        </div>
        <div className="form-input" id="contact-form-input-01">
            <label htmlFor="contact-form-input-field-01">
                { `${ t('estimation.form.name') } *` }
            </label>
            <input
              type="text"
              name="name"
              id="contact-form-input-field-01"
              value={ name }
              className={ cx({ error: error.name }) }
              onChange={ handleChange }
              maxLength={ 50 }
            />
        </div>
        <div className="form-input" id="contact-form-input-02">
            <label htmlFor="contact-form-input-field-02">
                { `${ t('estimation.form.mail') } *` }
            </label>
            <input
              type="email"
              name="email"
              id="contact-form-input-field-02"
              value={ email }
              className={ cx({ error: error.email }) }
              onChange={ handleChange }
              maxLength={ 100 }
            />
        </div>
        <div className="form-input" id="contact-form-input-03">
            <label htmlFor="contact-form-input-field-03">
                { t('estimation.form.phone') }
            </label>
            <input
              type="text"
              name="phone"
              id="contact-form-input-field-03"
              value={ phone }
              className={ cx({ error: error.phone }) }
              onChange={ handleChange }
              maxLength={ 20 }
            />
        </div>
        <div className="form-textarea" id="contact-form-textarea">
            <label htmlFor="contact-form-textarea-field">
                { t('estimation.form.message') }
            </label>
            <textarea
              name="message"
              id="contact-form-textarea-field"
              value={ message }
              className={ cx({ error: error.message }) }
              onChange={ handleChange }
            />
        </div>
        <div className="form-checkboxes">
            <div className="form-checkbox" id="contact-form-checkbox-01">
                <input
                  type="checkbox"
                  name="agreement_data"
                  id="contact-form-checkbox-agree-data"
                  checked={ agreement_data }
                  onChange={ handleChange }
                />
                <label htmlFor="contact-form-checkbox-agree-data" className={ cx({ error: error.agreement_data }) }/>
                <Consent t={ t } required content={ consents.contact.text } title={ consents.contact.label }/>
            </div>
            <div className="form-checkbox" id="contact-form-checkbox-02">
                <input
                  type="checkbox"
                  name="agreement_marketing"
                  id="contact-form-checkbox-agree-marketing"
                  checked={ agreement_marketing }
                  onChange={ handleChange }
                />
                <label htmlFor="contact-form-checkbox-agree-marketing" className={ cx({ error: error.agreement_marketing }) }/>
                <Consent t={ t } content={ consents.marketing.text } title={ consents.marketing.label }/>
            </div>
            <div className="form-checkbox" id="contact-form-checkbox-03">
                <input
                  type="checkbox"
                  name="agreement_rodo"
                  id="contact-form-checkbox-agree-rodo"
                  checked={ agreement_rodo }
                  onChange={ handleChange }
                />
                <label htmlFor="contact-form-checkbox-agree-rodo" className={ cx({ error: error.agreement_rodo }) }/>
                <Consent t={ t } required content={ consents.rodo.text } title={ consents.rodo.label }/>
            </div>
        </div>
        {
            errorType === 'recaptcha_error' ?
                <div className="form-button form-button-gray" id="contact-form-button-refresh-container">
                    <button id="contact-form-button-refresh" onClick={ () => window.location.reload() }>{ t('estimation.form.refresh') }</button>
                </div> :
                responseType !== 'success' &&
                <div className="form-button form-button-gray" id="contact-form-button-submit-container">
                    <button
                      disabled={ sending }
                      type="submit"
                      id="contact-form-button-submit"
                    >{ t('estimation.form.send') }
                    </button>
                </div>
        }
        {
            responseType && (responseType === 'success' ?
                <div className={ cx('form-message', responseType) } id={ cx('form-message', responseType) }>
                    <span>{ t(`form.message.${ responseType }`) }</span>
                </div>
                :
                <div className={ cx('form-message', 'error') } id={ cx('form-message', 'error') }>
                    <span>{ t(`form.message.${ errorType }`) }</span>
                </div>
            )
        }

    </div>
);

FormInputs.defaultProps = {
    responseType: null,
    errorType: null
};

FormInputs.propTypes = {
    t: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    agreement_data: PropTypes.bool.isRequired,
    agreement_marketing: PropTypes.bool.isRequired,
    agreement_rodo: PropTypes.bool.isRequired,
    error: PropTypes.shape().isRequired,
    responseType: PropTypes.string,
    errorType: PropTypes.string,
    consents: PropTypes.objectOf(Object).isRequired,
    sending: PropTypes.bool.isRequired
};

export default FormInputs;



// WEBPACK FOOTER //
// ./src/components/content/estimation/form/FormInputs.jsx